import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FooterVisibilityService {
  private readonly _footerVisible$ = new BehaviorSubject<boolean>(true);

  readonly footerVisible$: Observable<boolean> = this._footerVisible$.asObservable();

  hide(): void {
    this._footerVisible$.next(false);
  }

  show(): void {
    this._footerVisible$.next(true);
  }
}
